module.exports = __webpack_public_path__ + "static/media/Videos 3.dce12a58.svg";